import { render } from "./DefaultDetailContent.vue?vue&type=template&id=4bd6b6a6&scoped=true"
import script from "./DefaultDetailContent.vue?vue&type=script&lang=js"
export * from "./DefaultDetailContent.vue?vue&type=script&lang=js"

import "./DefaultDetailContent.vue?vue&type=style&index=0&id=4bd6b6a6&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd6b6a6"]])

export default __exports__